export default __webpack_public_path__ + "static/3-746e426565037c2ae9b14d13ef131b92.png";